// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"258c6ba2","346":"9a0429cf","466":"84a07601","501":"bc7f1f29","561":"62abb697","675":"b83bf70b"}[chunkId] + ".chunk.css";
};